





import { Component, Vue, Watch } from 'vue-property-decorator'
import APIClient from '@/API/APIClient'
import { Action, namespace } from 'vuex-class'
import { ActionMethod, MutationMethod } from 'vuex'
import browser from 'browser-detect'

const partyRoomModule = namespace('partyRoom')
const userModule = namespace('user')

@Component
export default class App extends Vue {
  @userModule.Action('signIn') dispatchSignIn!: ActionMethod
  @partyRoomModule.Getter('partyID') partyID!: string
  @partyRoomModule.Action('fetchRoom') dispatchFetchRoom!: ActionMethod
  @userModule.Mutation('setUser') setUser!: MutationMethod
  @partyRoomModule.Action('mountQueue') mountQueue!: ActionMethod
  @partyRoomModule.Action('mountVotesForNext') mountVotesForNext!: ActionMethod
  @userModule.Mutation('setHasAuthorizedSpotify') setHasAuthorizedSpotify!: MutationMethod
  @userModule.Action('mountSongsVotedFor') mountSongsVotedFor!: ActionMethod
  @userModule.Getter('userID') userID!: string

  @Watch('partyID')
  onPartyIDChanged (val: string) {
    if (val.length > 0) {
      this.mountQueue(this.partyID)
      this.mountVotesForNext(this.partyID)
      this.mountSongsVotedFor()
    }
  }

  /*  @Watch('userID')
  async onUserIDChanged (val: string) {
    if (val.length > 0) {

    }
  } */

  @Watch('window', { immediate: true })
  onWindowChange () {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  async mounted () {
    if (!browser().mobile) {
      window.location.assign('https://player.queued.no')
    }
    await this.dispatchSignIn()
    if (this.$route.query.code && this.$route.query.state) {
      const code = this.$route.query.code as string
      const state = (this.$route.query.state as string).split('!')
      const partyID = state[0]
      const userID = state[1]
      this.dispatchFetchRoom(partyID)
      const user = await APIClient.User.fetchUser(partyID, userID)
      user.exists ? this.setUser(user.data()) : this.$router.push('/enter')
      this.setUser(user.data())
      this.setHasAuthorizedSpotify(true)
      await APIClient.Spotify.getToken(true, code)
      this.$router.push('/' + partyID)
    } else if (this.$route.path.length === 7) {
      const partyID = this.$route.path.slice(0)
      this.dispatchFetchRoom(partyID)
      const user = await APIClient.User.fetchUser(partyID, this.userID)
      user.exists ? this.setUser(user.data()) : this.$router.push('/enter')
    } else {
      this.$router.push('/')
      APIClient.Spotify.getToken()
    }
  }
}
